import React from "react";
import type { SpacerBlock } from "../../../types/content";
import styles from "./Spacer.module.css";

export interface SpacerProps {
  block: SpacerBlock;
  className?: string;
}

/**
 * Spacer component - provides vertical and/or horizontal space.
 * Set height to 0 for a purely horizontal spacer (uses columnSpan from BlockGrid).
 */
export const Spacer: React.FC<SpacerProps> = ({ block, className }) => {
  const height = block.height ?? 48;

  const containerClasses = [styles.spacer, className].filter(Boolean).join(" ");

  return (
    <div
      className={containerClasses}
      data-component="spacer"
      style={{ height: `${height}px` }}
      aria-hidden="true"
    />
  );
};

export default Spacer;
